module.exports = __webpack_public_path__ + "104feb7e9b5514db016426791a25b1da.ttf";